import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const dextTextInputViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map